import { render } from "./ListCertifications.vue?vue&type=template&id=2ea84e1c"
import script from "./ListCertifications.vue?vue&type=script&lang=js"
export * from "./ListCertifications.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/organization/certifications/query_formats/list_certifications.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fcertifications%2Fquery_formats%2FListCertifications.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__